import * as React from "react";
import type { SVGProps } from "react";
const Datacenter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4362_1280)">
      <path
        fill="currentColor"
        d="M3 1C1.3453 1 0 2.3453 0 4v3c0 1.6547 1.3453 3 3 3h18c1.6547 0 3-1.3453 3-3V4c0-1.6547-1.3453-3-3-3zm13.125 3.375a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25m2.25 1.125a1.125 1.125 0 1 1 2.2498 0 1.125 1.125 0 0 1-2.2498 0M3 13c-1.6547 0-3 1.3453-3 3v3c0 1.6547 1.3453 3 3 3h18c1.6547 0 3-1.3453 3-3v-3c0-1.6547-1.3453-3-3-3zm13.125 3.375a1.1249 1.1249 0 1 1 .0001 2.2498 1.1249 1.1249 0 0 1-.0001-2.2498M18.75 17.5a1.1249 1.1249 0 1 1 2.2498-.0001A1.1249 1.1249 0 0 1 18.75 17.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_4362_1280">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default Datacenter;
